import { createContext } from "react";

export interface ILeftDrawerContext {
  open: boolean;
  content: React.JSX.Element;
  openDrawer: (content: React.JSX.Element) => void;
  closeDrawer: () => void;
}

export const LeftDrawerContext = createContext<ILeftDrawerContext>(
  {} as ILeftDrawerContext,
);
